import { render, staticRenderFns } from "./Actus.vue?vue&type=template&id=efc32712"
import script from "./Actus.vue?vue&type=script&lang=js"
export * from "./Actus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports